import axios from 'axios'
import { Auth } from 'aws-amplify'
import { useAuthStore } from '../store'
import router from '../router'

const API_URL = import.meta.env.VITE_API_INVESTOR

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: API_URL,
})

api.interceptors.request.use(
  async (config) => {
    const auth = useAuthStore()
    if (config.headers) {
      const session = await Auth.currentSession()
      const bearerToken = session.getAccessToken().getJwtToken()
      auth.tokenBackoffice = bearerToken
      config.headers.Authorization = `Bearer ${bearerToken}`
      config.headers.email = `${auth.email}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        await Auth.currentSession()
      } catch {
        await router.push('/login')
      }
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default api
